import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';

import { PasswordRecoveryService } from '../../services';
import { AltEmailDataResponse, SessionError, ApplicationError, ServerError, DataResponse, LogData } from '../../models';
import { Router, ActivatedRoute } from '@angular/router';
import { PagesURLs } from '../pages.url';
import { ErrorsURLs } from '../../errors/errors.url';
import { AppSession } from 'src/app/models/app-session';
import {finalize} from "rxjs/operators";


@Component({
    selector: 'app-identification',
    templateUrl: './identification.component.html',
    standalone: false
})
export class IdentificationComponent implements OnInit {

  loading = false;
  submitted = false;
  identificationErrorKey = 'pages.identification.errors.invalid';
  // identificationPattern: RegExp = /(^$)|(^[a-zA-Z0-9]{1,}$)|(^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$)/;
  //identificationPattern: RegExp = /^((?!@uoc.edu).)*$/;
  identificationPattern: RegExp = /^[\s\S]*$/;
  gRecaptchaSiteKey: string;
  private captchaResponseToken: string = null;
  showCaptcha = true;


   idForm = new UntypedFormGroup({
    username: new UntypedFormControl(/*'', [Validators.required, Validators.pattern(this.identificationPattern)]*/)
   });

  constructor(
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private passwordRecoveryService: PasswordRecoveryService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.gRecaptchaSiteKey = AppSession.getGRecaptchaSiteKey();

    this.idForm = this.formBuilder.group({
      // username: ['', [Validators.pattern(this.identificationPattern)]],
      username: new UntypedFormControl('',
        { validators: [
            // Validators.email,
            Validators.pattern(this.identificationPattern)
          ], updateOn: 'blur'
        }),
      recaptcha: ['', Validators.required]
    });
    this.disableCaptcha();
  }

  get getIdForm() { return this.idForm.controls; }

  // Google reCaptcha functions
  resolved(captchaResponse: string) {
    this.captchaResponseToken = captchaResponse;
    console.log('Resolved reCaptcha token:' + captchaResponse);
  }
  expired() {
    this.captchaResponseToken = null;
  }
  gLang() {
    return this.translate.currentLang;
  }

  private disableCaptcha() {
    if (AppSession.getCaptchaConfig() === 'no') {
      this.showCaptcha = false;
      this.captchaResponseToken = '';
      this.idForm = this.formBuilder.group({
        username: ['', [Validators.pattern(this.identificationPattern)]]
      });
    }
    console.log('Show Captcha: ' + this.showCaptcha);
  }

  formValid() {
    // console.log('formValid? ' + this.idForm.valid + ':' + this.getIdForm.username.value + ':' + this.captchaResponseToken);
    let formValid = false;
    if (this.idForm.valid
      && this.getIdForm.username.value !== ''
      && this.captchaResponseToken !== null
    ) { formValid = true; }
    return formValid;
  }

  onSubmit() {
    this.submitted = true;

    if (this.getIdForm.username.value === '') {
      this.getIdForm.username.setErrors({incorrect: true});
      return;
    }

    if (this.idForm.invalid) {
      console.warn('Invalid idForm: ' + this.getIdForm.username.value + ':' + this.captchaResponseToken);
      return;
    }

    const identityType = (this.getIdForm.username.value).includes('@') ? LogData.logidenttypeMail : LogData.logidenttypeLogin;
    this.log(identityType, AppSession.getLogKeys().logKey1, this.getIdForm.username.value, '');
    try {
      this.loading = true;
      this.passwordRecoveryService.changePasswordRequest(this.getIdForm.username.value, this.captchaResponseToken)
        .pipe(
          finalize(() => this.loading = false)
        )
        .subscribe(
          (response: AltEmailDataResponse) => {
            // console.log(response.data);
            // console.log(response.data[0].altemail);
            this.router.navigate(
              [ PagesURLs.IDENTIFICATION_SUCCESS, { altEmail: response.data[0].altemail }],
              { relativeTo: this.activatedRoute.root, skipLocationChange: true }
            );
          },
          (error: Error) => {
            this.processError(error);
          }
        );
    }
    catch (error) {
      console.error(error);
      this.router.navigate([ErrorsURLs.IDENTIFICATION_FAILED],
        { relativeTo: this.activatedRoute.root, skipLocationChange: true });
    }

  }

  private log(identityType: string, keyLog: string, param0: string, param1: string) {
    try {
      console.log(keyLog + ':' + param0 + ':' + param1);
      this.passwordRecoveryService.log(identityType, keyLog, param0, param1).subscribe((response: DataResponse) => {
        console.log(response);
      });
    }
    catch (error) {
      console.error(keyLog + ' could not be logged');
      console.error(error);
    }
  }

  private processError(error: Error) {
    switch (error.constructor) {
      case SessionError: {
        // console.warn(error.name);
        this.router.navigate([ErrorsURLs.INVALID_SESSION],
          { relativeTo: this.activatedRoute.root, skipLocationChange: true });
        break;
      }
      case ApplicationError: {
        // console.warn(error.name);
        this.getIdForm.username.setErrors({incorrect: true});
        break;
      }
      case ServerError: {
        // console.error(error.name);
        this.router.navigate([ErrorsURLs.IDENTIFICATION_FAILED],
          { relativeTo: this.activatedRoute.root, skipLocationChange: true });
        break;
      }
      default: {
        // console.error(error.name);
        this.router.navigate([ErrorsURLs.REQUEST_FAILED],
          { relativeTo: this.activatedRoute.root, skipLocationChange: true });
        break;
      }
    }
  }
}
